// extracted by mini-css-extract-plugin
module.exports = {"form":"SalesSiteCommissionReportForm_form__3L-Si"};